import { ElementRef, Injectable, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { DashboardAdHintOption } from './dashboard-ad-hint.model';

@Injectable({
  providedIn: 'root',
})
export class DashboardAdHintService {
  private active: boolean = false;
  private option: DashboardAdHintOption[] = [];
  private _firstOption = new Subject<DashboardAdHintOption | undefined | null>();
  public firstOptionSource = this._firstOption.asObservable();
  constructor() {
    this._firstOption.next(null);
  }

  add(hintsOption: DashboardAdHintOption[]) {
    hintsOption.forEach((item) => {
      const elemName = `[data-ad-hint="${item.key}"]`;
      const elem = <HTMLElement>document.querySelector(elemName);
      if (elem) {
        // add indicator
        elem.setAttribute('data-ad-hint-indicate', ''); 
        if (elem.classList.contains('data-ad-hint-indicate--right')) {
          item.position = 'right';
        }
        this.option.push(item);
      }else{
        this.onDismissed();
      }
    });
    this.publish(false);
  }

  private publish(isOnDismissed: boolean) {
    if (this.option.length > 0 && !this.active) {
      this.show();
    } else {
      if (isOnDismissed) {
        this._firstOption.next(null);
      }
    }
  }

  onDismissed() {
    if(!this.active) return;

    const elem = <HTMLElement>document.querySelector(`[data-ad-hint="${this.option[0].key}"]`);
    elem?.removeAttribute('data-ad-hint-indicate');
    this.active = false;

    this.option.splice(0, 1);
    this.publish(true);
  }

  private show() {
    // calculation should come here.
    let first = this.option[0];
    const elem = <HTMLElement>document.querySelector(`[data-ad-hint="${first.key}"]`);
    let offset = this.getOffset(elem, first);

    // scroll
    let positionY = window.innerHeight * 2 / 3
    if (offset.top > positionY) {
      const main = <HTMLElement>document.getElementById(`page-cntr`);
      main.scroll(0, (offset.top - positionY) + main.scrollTop);
      offset.top = offset.top - (offset.top - positionY);
    }

    this.active = true;
    this._firstOption.next({ ...first, ...offset });
  }

  async updatePreference() {}

  getOffset(el: HTMLElement, option: DashboardAdHintOption) {
    const rect = el.getBoundingClientRect();

    const { left, top, width, height } = {
      left: Math.round(rect.left + window.scrollX),
      top: Math.round(rect.top + window.scrollY),
      width: Math.round(el.offsetWidth),
      height: Math.round(el.offsetHeight),
    };

    let calculatedLeft = left + width / 2 - 13.5;
    let pointLeft = 0;
    if (option.position == 'right') {
      calculatedLeft = Math.round(rect.right)-30;
    }    
    if (calculatedLeft + 380 > window.innerWidth) {
      pointLeft = (calculatedLeft + 397) - window.innerWidth; //  + width / 2
      calculatedLeft = window.innerWidth - 400;
    }

    let calculatedTop = top-10;
   
    return {
      left: calculatedLeft,
      top: calculatedTop,
      width: width,
      height: height,
      pointLeft: pointLeft,
    };
  }
}